import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'

import './gallery-form.scss'

Fancybox.bind('[data-fancybox="gallery"]')
